import * as React from 'react'
import { MoonLoader } from 'react-spinners'
import { RouteComponentProps, Redirect } from 'react-router'
import { TripStatuses } from '../../constants/trip-statuses'
import { IActiveTripResponseV2, ITripEdit } from '../../types'
import Modal from '../ui/Modal'
import UIMessages from '../../utils/ui-messages'

interface IRouteParams {
  tripId: string
}

interface IManualTripCancelModalProps extends RouteComponentProps<IRouteParams> {
  currentTrip: IActiveTripResponseV2
  loading: boolean
  cancelTrip: (tripId: string, comment: string) => Promise<any>
  getTripById: (tripId: string) => any
  close: () => void
  saveData: (params: ITripEdit) => Promise<any>
  currentTripId?: string
}

export default class ManualTripCancelModal extends React.Component<IManualTripCancelModalProps> {
  public state = {
    reason: '',
    otherReason: ''
  }

  public render() {
    let currentTripStatus

    if (!this.props.currentTrip) {
      if (
        this.props.currentTripId !== null &&
        this.props.currentTripId !== undefined &&
        this.props.currentTripId !== ''
      ) {
        const response = this.props.getTripById(this.props.currentTripId)
        currentTripStatus = response.lastStatus
        return (
          <div className='flex flex-column justify-center items-center' style={{ width: '90%', height: '40vh' }}>
            <MoonLoader sizeUnit={'px'} size={40} color={'#405264'} loading={true} />
            <span className='pt1'>Loading...</span>
          </div>
        )
      } else {
        return (
          <div className='flex flex-column justify-center items-center' style={{ width: '90%', height: '40vh' }}>
            <span className='pt1'>INVALID TRIP ID</span>
          </div>
        )
      }
    }

    currentTripStatus = this.props.currentTrip.lastStatus

    const tripStatus = currentTripStatus

    if (
      tripStatus === TripStatuses.COMPLETED ||
      tripStatus === TripStatuses.CANCELLED ||
      tripStatus === TripStatuses.MANUALLY_COMPLETED
    ) {
      return <Redirect to={`/trips/${this.props.currentTrip.id}`} />
    }
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='bg-white col-4 p2'>
            <span className='ModalAddTitle weight-300 font-grey2 ml2 mr2 mb1 h3'>
              {UIMessages.manualTripCancel.modalTitle}
            </span>
            <div className='mt1'>
              <span>{UIMessages.manualTripCancel.reasonQuestion}</span>
              <div className='mt1' onChange={this.handleSelect}>
                {UIMessages.manualTripCancel.cancelReasons.map((reason, i) => (
                  <div key={i}>
                    <label>
                      <input type='radio' name='reason' value={reason} defaultChecked={this.state.reason === reason} />
                      <span>{reason}</span>
                    </label>
                  </div>
                ))}
              </div>
              <div className='mb1' onChange={this.handleOtherReasonUpdate}>
                <textarea
                  className='col-12 p1 fit'
                  disabled={this.state.reason !== 'Other'}
                  value={this.state.otherReason}
                />
              </div>
            </div>
            <div className='mt1'>
              <button
                type='button'
                onClick={this.props.close}
                className='CancelButton btn bg-white rounded font-light-grey mr2'
              >
                {UIMessages.common.cancel}
              </button>
              <button
                type='submit'
                className='SubmitButton btn bg-green rounded weight-300'
                onClick={this.cancelTrip}
                disabled={
                  this.props.loading ||
                  this.state.reason === '' ||
                  (this.state.reason === 'Other' && this.state.otherReason === '')
                }
              >
                <span className='font-white flex items-center'>
                  Submit
                  {this.props.loading ? (
                    <MoonLoader sizeUnit={'px'} size={20} color={'#405264'} loading={true} />
                  ) : (
                    <React.Fragment />
                  )}
                </span>
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }

  private handleSelect = (event: any) => {
    this.setState({
      reason: event.target.value
    })
  }

  private handleOtherReasonUpdate = (event: any) => {
    this.setState({
      otherReason: event.target.value
    })
  }

  private cancelTrip = async () => {
    const comment = this.state.reason === 'Other' ? this.state.otherReason : this.state.reason
    if (comment || !comment) {
      //Audit Trail
      const params: ITripEdit = {
        prevNotes: this.props.currentTrip.lastStatus
      }
      await this.props.saveData(params)
    }

    this.props.cancelTrip(this.props.currentTrip.id, comment).then(() => {
      if (this.props.currentTrip && this.props.currentTrip.id) {
        this.props.getTripById(this.props.currentTrip.id)
      }
      this.props.close()
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/trips/ManualTripCancelModal.tsx